<template>
  <div class="PaymentsReport">
    <h1 class="text-center my-7">گزارشات آزمون های برگزار شده</h1>
    <v-alert type="info">
      به صورت پیش فرض اطلاعات تا یک ماه قبل نمایش داده می شود
    </v-alert>
    <v-row>
      <v-col cols="12" md="3" class="px-2">
        <Navigation />
      </v-col>
      <v-col cols="12" md="9" class="px-2">
        <div class="mb-10 d-flex align-center">
          <div class="ml-5 position-relative flex-fill">
            <v-text-field
              id="pStartDate"
              label="تاریخ شروع"
              v-model="pStartDate"
              class="pa-0"
              hide-details="auto"
            />
            <date-picker
              v-model="pStartDate"
              :auto-submit="true"
              format="jYYYY/jMM/jDD"
              element="pStartDate"
              alt-name="startDate"
              alt-format="YYYY-MM-DD HH:mm:ss"
            />
          </div>
          <div class="ml-5 position-relative flex-fill">
            <v-text-field
              id="pEndDate"
              label="تاریخ پایان"
              v-model="pEndDate"
              class="pa-0"
              hide-details="auto"
            />
            <date-picker
              v-model="pEndDate"
              :auto-submit="true"
              format="jYYYY/jMM/jDD"
              element="pEndDate"
              alt-name="endDate"
              alt-format="YYYY-MM-DD HH:mm:ss"
            />
          </div>

          <v-btn depressed color="primary" class="mb-0" @click="updateData">
            جستجو
          </v-btn>
        </div>
        <h4 class="mb-5">
          گزارش تعداد خرید های انجام شده بر اساس استان - کتاب
        </h4>
        <v-card class="mb-10">
          <v-card-title>
            <v-text-field
              v-model="stateSearch"
              class="pa-0"
              append-icon="mdi-magnify"
              label="جستجو"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="stateHeaders"
              :items="states"
              :search="stateSearch"
              :loading="loading"
              :items-per-page="5"
            >
              <template v-slot:[`item.count`]="{ item }">
                <number :number="item.count"></number>
              </template>
              <template v-slot:[`item.sum`]="{ item }">
                <number :number="item.sum" unit="تومان"></number>
              </template>
              <template v-slot:[`item._id`]="{ item }">
                <v-btn
                  outlined
                  depressed
                  color="primary"
                  router
                  :to="{
                    name: 'PaymentsStateReport',
                    params: { id: item._id }
                  }"
                >
                  مشاهده خرید های انجام شده در این استان به تفکیک شهرستان
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
        <apex-chart
          v-if="!loading"
          ref="lineChart"
          type="line"
          height="700"
          class="mb-10"
          :options="stateChartOptions"
          :series="stateChartSeries"
        />
        <h4 class="mb-5">
          گزارش تعداد خرید های انجام شده بر اساس استان - کد تخفیف
        </h4>
        <v-card class="mb-10">
          <v-card-title>
            <v-text-field
              v-model="stateDisSearch"
              class="pa-0"
              append-icon="mdi-magnify"
              label="جستجو"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="stateDisHeaders"
              :items="statesDis"
              :search="stateDisSearch"
              :loading="loading"
              :items-per-page="5"
            >
              <template v-slot:[`item.count`]="{ item }">
                <number :number="item.count"></number>
              </template>
              <template v-slot:[`item.sum`]="{ item }">
                <number :number="item.sum" unit="تومان"></number>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
        <apex-chart
          v-if="!loading"
          ref="lineChart"
          type="line"
          height="700"
          class="mb-10"
          :options="stateDisChartOptions"
          :series="stateDisChartSeries"
        />
        <h4 class="mb-5">گزارش تعداد خرید - 20 شهرستان برتر - کتاب</h4>
        <v-card class="mb-10">
          <v-card-title>
            <v-text-field
              v-model="citiesSearch"
              class="pa-0"
              append-icon="mdi-magnify"
              label="جستجو"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="citiesHeaders"
              :items="cities"
              :search="citiesSearch"
              :loading="loading"
              :items-per-page="5"
            >
              <template v-slot:[`item.count`]="{ item }">
                <number :number="item.count"></number>
              </template>
              <template v-slot:[`item.sum`]="{ item }">
                <number :number="item.sum" unit="تومان"></number>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
        <apex-chart
          v-if="!loading"
          ref="lineChart"
          type="line"
          height="700"
          class="mb-10"
          :options="cityChartOptions"
          :series="cityChartSeries"
        />
        <h4 class="mb-5">گزارش تعداد خرید های انجام شده بر اساس کتاب</h4>
        <v-card class="mb-10">
          <v-card-title>
            <v-text-field
              v-model="bookSearch"
              class="pa-0"
              append-icon="mdi-magnify"
              label="جستجو"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="bookHeaders"
              :items="books"
              :search="bookSearch"
              :loading="loading"
              :items-per-page="5"
            >
              <template v-slot:[`item.count`]="{ item }">
                <number :number="item.count"></number>
              </template>
              <template v-slot:[`item.sum`]="{ item }">
                <number :number="item.sum" unit="تومان"></number>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
        <apex-chart
          v-if="!loading"
          ref="lineChart"
          type="line"
          height="700"
          class="mb-10"
          :options="bookChartOptions"
          :series="bookChartSeries"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Navigation from "../_Navigation.vue";

export default {
  name: "payments-report-component",
  components: {
    Navigation
  },
  data() {
    return {
      loading: false,
      pStartDate: "",
      pEndDate: "",
      stateHeaders: [
        { text: "استان", value: "name", align: "center" },
        { text: "تعداد خرید انجام شده", value: "count", align: "center" },
        { text: "مجموع خرید", value: "sum", align: "center" },
        { text: "اقدامات", value: "_id", align: "center" }
      ],
      states: [],
      stateSearch: "",
      stateDisHeaders: [
        { text: "استان", value: "state", align: "center" },
        { text: "تعداد خرید انجام شده", value: "count", align: "center" },
        { text: "مجموع خرید", value: "sum", align: "center" }
      ],
      statesDis: [],
      stateDisSearch: "",
      citiesHeaders: [
        { text: "استان", value: "name", align: "center" },
        { text: "تعداد خرید انجام شده", value: "count", align: "center" },
        { text: "مجموع خرید", value: "sum", align: "center" }
      ],
      cities: [],
      citiesSearch: "",
      bookHeaders: [
        { text: "نام کتاب", value: "title", align: "center" },
        { text: "مقطع", value: "grade", align: "center" },
        { text: "کتاب شماره", value: "level", align: "center" },
        { text: "تعداد خرید انجام شده", value: "count", align: "center" },
        { text: "مجموع خرید", value: "sum", align: "center" }
      ],
      books: [],
      bookSearch: "",
      stateChartSeries: [
        {
          name: "مجموع قیمت",
          data: []
        }
      ],
      stateDisChartSeries: [
        {
          name: "مجموع قیمت",
          data: []
        }
      ],
      cityChartSeries: [
        {
          name: "مجموع قیمت",
          data: []
        }
      ],
      bookChartSeries: [
        {
          name: "مجموع قیمت",
          data: []
        }
      ],
      stateChartOptions: {
        chart: {
          type: "line",
          fontFamily: "dana"
        },
        title: {
          text: "میانگین نمرات آزمون های برگزار شده بر اساس استان",
          align: "center",
          margin: 30,
          style: {
            fontSize: "20px"
          }
        },
        markers: {
          size: 6,
          colors: "#F4A046"
        },
        fill: {
          colors: ["#ffbe0b", "#FB5607", "#FF006E", "#8338EC", "#3A86FF"]
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {
          categories: [],
          position: "top",
          labels: {
            rotate: -90,
            rotateAlways: true,
            minHeight: 140,
            maxHeight: 200
          }
        },
        yaxis: {
          seriesName: "تعداد شرکت کننده",
          tickAmount: 10
        }
      },
      stateDisChartOptions: {
        chart: {
          type: "line",
          fontFamily: "dana"
        },
        title: {
          text: "میانگین نمرات آزمون های برگزار شده بر اساس استان",
          align: "center",
          margin: 30,
          style: {
            fontSize: "20px"
          }
        },
        markers: {
          size: 6,
          colors: "#F4A046"
        },
        fill: {
          colors: ["#ffbe0b", "#FB5607", "#FF006E", "#8338EC", "#3A86FF"]
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {
          categories: [],
          position: "top",
          labels: {
            rotate: -90,
            rotateAlways: true,
            minHeight: 140,
            maxHeight: 200
          }
        },
        yaxis: {
          seriesName: "تعداد شرکت کننده",
          tickAmount: 10
        }
      },
      cityChartOptions: {
        chart: {
          type: "line",
          fontFamily: "dana"
        },
        title: {
          text: "میانگین نمرات آزمون های برگزار شده بر اساس استان",
          align: "center",
          margin: 30,
          style: {
            fontSize: "20px"
          }
        },
        markers: {
          size: 6,
          colors: "#F4A046"
        },
        fill: {
          colors: ["#ffbe0b", "#FB5607", "#FF006E", "#8338EC", "#3A86FF"]
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {
          categories: [],
          position: "top",
          labels: {
            rotate: -90,
            rotateAlways: true,
            minHeight: 140,
            maxHeight: 200
          }
        },
        yaxis: {
          seriesName: "تعداد شرکت کننده",
          tickAmount: 10
        }
      },
      bookChartOptions: {
        chart: {
          type: "line",
          fontFamily: "dana"
        },
        title: {
          text: "میانگین نمرات آزمون های برگزار شده بر اساس کتاب",
          align: "center",
          margin: 30,
          style: {
            fontSize: "20px"
          }
        },
        markers: {
          size: 6,
          colors: "#F4A046"
        },
        fill: {
          colors: ["#ffbe0b", "#FB5607", "#FF006E", "#8338EC", "#3A86FF"]
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {
          categories: [],
          position: "top",
          labels: {
            rotate: -90,
            rotateAlways: true,
            minHeight: 140,
            maxHeight: 200
          }
        },
        yaxis: {
          seriesName: "تعداد شرکت کننده",
          tickAmount: 10
        }
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      this.$api
        .post("payments/reports")
        .then((res) => {
          const data = res.data;

          // state - book
          data.statesBooks.forEach((element) => {
            this.stateChartSeries[0].data.push(element.sum);
            this.stateChartOptions.xaxis.categories.push(element.name);
          });

          // state - discountcodes
          data.statesDiscountCodes.forEach((element) => {
            this.stateDisChartSeries[0].data.push(element.sum);
            this.stateDisChartOptions.xaxis.categories.push(element.state);
          });

          // cities - book
          data.citiesBooks.forEach((element) => {
            this.cityChartSeries[0].data.push(element.sum);
            this.cityChartOptions.xaxis.categories.push(element.name);
          });

          // book
          data.books.forEach((element) => {
            this.bookChartSeries[0].data.push(element.sum);
            this.bookChartOptions.xaxis.categories.push(element.title);
          });

          this.states = data.statesBooks;
          this.statesDis = data.statesDiscountCodes;
          this.cities = data.citiesBooks;
          this.books = data.books;

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    updateData() {
      this.loading = true;
      const startDate = document.getElementsByName("startDate")[0].value;
      const endDate = document.getElementsByName("endDate")[0].value;
      this.$api
        .post("payments/reports", {
          startDate: startDate,
          endDate: endDate
        })
        .then((res) => {
          const data = res.data;

          this.stateChartSeries[0].data = [];
          this.stateChartOptions.xaxis.categories = [];
          this.stateDisChartSeries[0].data = [];
          this.stateDisChartOptions.xaxis.categories = [];
          this.cityChartSeries[0].data = [];
          this.cityChartOptions.xaxis.categories = [];
          this.bookChartSeries[0].data = [];
          this.bookChartOptions.xaxis.categories = [];

          // state - book
          data.statesBooks.forEach((element) => {
            this.stateChartSeries[0].data.push(element.sum);
            this.stateChartOptions.xaxis.categories.push(element.name);
          });

          // state - discountcodes
          data.statesDiscountCodes.forEach((element) => {
            this.stateDisChartSeries[0].data.push(element.sum);
            this.stateDisChartOptions.xaxis.categories.push(element.state);
          });

          // cities - book
          data.citiesBooks.forEach((element) => {
            this.cityChartSeries[0].data.push(element.sum);
            this.cityChartOptions.xaxis.categories.push(element.name);
          });

          // book
          data.books.forEach((element) => {
            this.bookChartSeries[0].data.push(element.sum);
            this.bookChartOptions.xaxis.categories.push(element.title);
          });

          this.states = data.statesBooks;
          this.statesDis = data.statesDiscountCodes;
          this.cities = data.citiesBooks;
          this.books = data.books;

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style>
.PaymentsReport .apexcharts-xaxis-texts-g {
  transform: translate(0, 95px);
}
.PaymentsReport .apexcharts-yaxis {
  transform: translate(-97%, 0);
}
@media only screen and (max-width: 600px) {
  .PaymentsReport .apexcharts-xaxis-texts-g {
    transform: translate(0, 95px);
  }
}
</style>
